import { useT } from '@dia/i18n';
import { Button } from '@dia/ui';
import { RequireAuth } from './lib/identity';
import { NavRow, Page } from './lib/ui';

/**
 * The manager and owner hub. Crew never see it: the guard sends them back.
 *
 * Every row here is a Section 4 manager job (the stay list, pairing a phone,
 * reviewing a cleaning), so a manager and an owner see the same list. The way
 * home is the Hoy tab, always at the bottom of the screen.
 */
export function Jefe() {
  return (
    <RequireAuth need="manager">
      {(who) => <BossBody signOut={who.signOut} owner={who.kind === 'owner'} />}
    </RequireAuth>
  );
}

function BossBody({ signOut, owner }: { signOut: () => void; owner: boolean }) {
  const { t } = useT();
  return (
    <Page title={t('ops.boss.title')} back="/mas">
      <div className="flex flex-col gap-3">
        <NavRow to="/jefe/estadias" icon="users" title={t('ops.boss.stays')} hint={t('ops.boss.stays_hint')} />
        <NavRow to="/jefe/telefonos" icon="phone" title={t('ops.boss.phones')} hint={t('ops.boss.phones_hint')} />
        <NavRow to="/jefe/revisar" icon="check" title={t('ops.boss.review')} hint={t('ops.boss.review_hint')} />
        {owner && (
          <div className="mt-4">
            <Button variant="secondary" block onClick={signOut}>
              {t('action.sign_out')}
            </Button>
          </div>
        )}
      </div>
    </Page>
  );
}
